import InstallCertificate from "../../../../src/courses/partials/ssl/install-certificate.mdx";
import * as React from 'react';
export default {
  InstallCertificate,
  React
};